<template>
  <form @submit.prevent="submit" class="flex flex-col">
    <div class="input-item">
      <label>Email *</label>
      <input
        v-model="form.email"
        type="email"
        placeholder="customer@example.com"
        :class="['regular', 'bordered', 'full', { 'input-error': emailError }]"
        @input="emailError = null"
        required
      />
      <span v-if="emailError" class="email-error-msg">{{ emailError }}</span>
    </div>
    <div class="grid grid-cols-2 gap-2">
      <div class="input-item">
        <label>First Name *</label>
        <input
          v-model="form.name"
          type="text"
          placeholder="John"
          class="regular bordered full"
          required
        />
      </div>
      <div class="input-item">
        <label>Last Name *</label>
        <input
          v-model="form.surname"
          type="text"
          placeholder="Doe"
          class="regular bordered full"
          required
        />
      </div>
    </div>
    <div class="input-item">
      <label>Company Name</label>
      <input
        v-model="form.companyName"
        type="text"
        placeholder="Optional"
        class="regular bordered full"
      />
    </div>
    <div class="flex justify-center gap-2 mt-4">
      <button
        type="submit"
        :disabled="loading"
        class="btn-success-button flex-1 flex justify-center"
      >
        {{ loading ? "Creating..." : submitLabel }}
      </button>
      <button
        type="button"
        @click="reset"
        class="btn-secondary-button flex justify-center"
      >
        Reset
      </button>
    </div>
  </form>
</template>

<script>
import { createLinkedCustomer } from "@/api/store/CustomersService.js";

export default {
  name: "CreateWebCustomerForm",
  props: {
    infoautoId: {
      type: String,
      default: null
    },
    submitLabel: {
      type: String,
      default: "Create Customer"
    }
  },
  data() {
    return {
      form: {
        email: "",
        name: "",
        surname: "",
        companyName: ""
      },
      emailError: null,
      loading: false
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      try {
        const payload = {
          email: this.form.email,
          name: this.form.name,
          surname: this.form.surname,
          company_name: this.form.companyName,
          status: 1
        };
        if (this.infoautoId) {
          payload.infoauto_id = this.infoautoId;
        }
        const newCustomer = await createLinkedCustomer(payload);
        this.$emit("customerCreated", newCustomer);
        this.reset();
      } catch (err) {
        const msg = err.response?.data?.message || "";
        if (msg.toLowerCase().includes("already exists")) {
          this.emailError = msg;
        }
        this.$toast.open({
          message: msg || "Failed to create customer",
          type: "error",
          position: "top-right"
        });
      } finally {
        this.loading = false;
      }
    },
    reset() {
      this.form = { email: "", name: "", surname: "", companyName: "" };
      this.emailError = null;
    }
  }
};
</script>

<style lang="scss" scoped>
.input-item {
  @apply flex flex-col my-1;
  label {
    @apply text-sm font-medium text-gray-700 mb-1;
  }
}

input.input-error {
  border-color: #e53e3e !important;
  background-color: #fff5f5;
}

.email-error-msg {
  color: #e53e3e;
  font-size: 12px;
  margin-top: 4px;
}

.btn-secondary-button {
  @apply px-3 py-1 rounded text-sm font-medium border border-gray-300;
  background-color: #f5f5f5;
  color: #333;
  &:hover {
    background-color: #e8e8e8;
  }
}
</style>
